import { render, staticRenderFns } from "./tigerWallet.vue?vue&type=template&id=7865d1fa"
import script from "./tigerWallet.vue?vue&type=script&lang=js"
export * from "./tigerWallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports